import { Pokemon } from "prisma-layer";
import { StrokedText } from "@/components/ui/text/stroked-text";
import { POKEMON_SKILLS } from "game/data/skills/POKEMON_SKILLS";
import { MiniSkillCard } from "@/components/pokemon/mini-skill-card";
import cn from "classnames";
import { isXsScreen } from "@/utils/screen-size-check";
import { PokeTeamPokemon } from "@/types";

interface PokemonHoverDetailsProps {
  pokemon: PokeTeamPokemon;
  className?: string;
}

export const PokemonHoverDetails = ({
  pokemon,
  className,
}: PokemonHoverDetailsProps) => {
  const activeSkills =
    pokemon.active_skills?.map((skillId) => POKEMON_SKILLS[skillId]) ?? [];

  const isXs = isXsScreen();

  return (
    <div
      className={cn(
        "flex flex-col gap-3 bg-pk-orange-3 p-2 pt-6 rounded-b-sm w-full",
        className,
      )}
    >
      {/* Row 2: Skills */}
      <div className="flex flex-col gap-1 bg-black/20 p-2 rounded-lg w-full">
        <span className="mb-1 font-semibold text-pk-orange-5 text-lg">
          Active Skills
        </span>
        <div
          className={cn(
            "gap-2 grid grid-cols-3 w-full",
            isXs ? "h-auto" : "h-[100px]",
          )}
        >
          {activeSkills.length === 0 && (
            <div className="flex justify-center items-center col-span-3 opacity-50 w-full h-full">
              <StrokedText fontSize={18} strokeWidth={8}>
                No Active Skills
              </StrokedText>
            </div>
          )}
          {activeSkills.map((skill, index) =>
            skill ? (
              <div key={skill.id} className="w-full h-full">
                <MiniSkillCard skill={skill} />
              </div>
            ) : (
              <div
                key={index}
                className="bg-pk-gray-2/20 border-2 border-pk-gray-4/20 border-dashed rounded-lg w-full h-full"
              ></div>
            ),
          )}
          {/* Fill empty slots if less than 3 skills */}
          {Array.from({ length: Math.max(0, 3 - activeSkills.length) }).map(
            (_, index) => (
              <div
                key={`empty-${index}`}
                className="bg-pk-gray-2/20 border-2 border-pk-gray-4/20 border-dashed rounded-lg w-full h-full"
              ></div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};
